module.exports = {"name":"soundcloud","type":"adapter","tech":"js","author":"Anita Campbell","version":"6.1.0","built":"2018-01-25","repo":"https://bitbucket.org/npaw/soundcloud-adapter-js","libVersion":"6.1.X","features":{"buffer":"monitor","seek":"native","getters":["getPlayhead","getDuration","getIsLive"]},"ads":[]}


//////////////////
// WEBPACK FOOTER
// ./manifest.json
// module id = 26
// module chunks = 0